import { render, staticRenderFns } from "./UiCropper.vue?vue&type=template&id=51ea97e2&lang=pug&"
import script from "./UiCropper.vue?vue&type=script&lang=js&"
export * from "./UiCropper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports